import { DataItemFormatter } from '@creditsights/styleguide-web';
import { ReactElement } from 'react';
import { ArticleTableRow } from '../../../models/ArticleTableRow';
import ArticleContextMenu from '../../ArticleContextMenu';

const ContextMenuRenderer: DataItemFormatter<
  string,
  ReactElement,
  { stopMouseUpPropagation: boolean },
  ArticleTableRow
> = ({ item }) => {
  return <ArticleContextMenu disabled={!item.canAccess} articleTableRow={item} />;
};

export default ContextMenuRenderer;
